import { useState } from 'react';
import { Box, Button, Typography, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';

import { FANTASY, FANTASY_MODE } from '@/helpers/biwenger-helper';

import CustomImageComponent from '../../shared/custom/custom-image';
import FantasyLaLigaIcon from '../../shared/icons/fantasy-la-liga-icon';
import MisterFantasyIcon from '@/components/shared/icons/MisterFantasyIcon';
import FantasyMarcaIcon from '@/components/shared/icons/FantasyMarcaIcon';
import BiwengerIcon from '@/components/shared/icons/biwenger-icon';

const EquipoModeSelector = ({ mode, setMode, subMode, setSubMode }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const size = 20;

    // Definir todas las opciones disponibles
    const modeOptions = [
        {
            id: 'information',
            mode: FANTASY.INFORMATION,
            subMode: null,
            label: 'Analítica Fantasy',
            icon: (
                <CustomImageComponent
                    src={`${process.env.NEXT_PUBLIC_IMAGES}/analiticafantasy.png?width=${size * 1.5}`}
                    alt="af logo"
                    width={size}
                    height={size}
                />
            ),
        },
        {
            id: 'fantasy-liga',
            mode: FANTASY.FANTASY,
            subMode: null,
            label: 'La Liga Fantasy',
            icon: <FantasyLaLigaIcon iconWidth={size} iconHeight={size} />,
        },
        {
            id: 'biwenger-as',
            mode: FANTASY.BIWENGER,
            subMode: FANTASY_MODE.DIARIO_AS,
            label: 'Biwenger - AS',
            icon: <BiwengerIcon width={size} height={size} />,
        },
        {
            id: 'biwenger-sofa',
            mode: FANTASY.BIWENGER,
            subMode: FANTASY_MODE.SOFASCORE,
            label: 'Biwenger - SOFASCORE',
            icon: <BiwengerIcon width={size} height={size} />,
        },
        {
            id: 'biwenger-stats',
            mode: FANTASY.BIWENGER,
            subMode: FANTASY_MODE.STATS,
            label: 'Biwenger - STATS',
            icon: <BiwengerIcon width={size} height={size} />,
        },
        {
            id: 'biwenger-average',
            mode: FANTASY.BIWENGER,
            subMode: FANTASY_MODE.AVERAGE,
            label: 'Biwenger - AS + SOFA',
            icon: <BiwengerIcon width={size} height={size} />,
        },
        {
            id: 'biwenger-social',
            mode: FANTASY.BIWENGER,
            subMode: FANTASY_MODE.SOCIAL,
            label: 'Biwenger - SOCIAL',
            icon: <BiwengerIcon width={size} height={size} />,
        },
        {
            id: 'fantasy-marca',
            mode: FANTASY.FANTASY_MARCA,
            subMode: null,
            label: 'Fantasy Marca',
            icon: <FantasyMarcaIcon width={size} height={size} />,
        },
        {
            id: 'mister-fantasy',
            mode: FANTASY.MISTER_FANTASY,
            subMode: null,
            label: 'Mister Fantasy',
            icon: <MisterFantasyIcon width={size} height={size} />,
        },
    ];

    const getCurrentOption = () => {
        return (
            modeOptions.find((option) => option.mode === mode && option.subMode === subMode) || modeOptions[0]
        );
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOptionSelect = (option) => {
        setMode(option.mode);
        setSubMode(option.subMode);
        handleClose();
    };

    const currentOption = getCurrentOption();

    return (
        <Box display="flex" alignItems="center" width="100%" mb={1}>
            <Button
                variant="outlined"
                onClick={handleClick}
                sx={{
                    width: '100%',
                    justifyContent: 'space-between',
                    textTransform: 'none',
                    height: '40px',
                    border: '1px solid',
                    borderColor: 'border.main',
                    borderRadius: '4px',
                    padding: '0 16px',
                    '&:hover': {
                        border: '1px solid rgba(0, 0, 0, 0.87)',
                    },
                }}
            >
                <Box display="flex" alignItems="center" gap={1}>
                    {currentOption.icon}
                    <Typography variant="body2" fontSize={14}>
                        {currentOption.label}
                    </Typography>
                </Box>
                <KeyboardArrowDown />
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        minWidth: 250,
                        maxHeight: 400,
                    },
                }}
            >
                {modeOptions.map((option) => (
                    <MenuItem
                        key={option.id}
                        onClick={() => handleOptionSelect(option)}
                        selected={option.mode === mode && option.subMode === subMode}
                    >
                        <ListItemIcon>{option.icon}</ListItemIcon>
                        <ListItemText primary={option.label} />
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};

export default EquipoModeSelector;
